import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["anchorEl", "isOpen", "onClose", "role", "children"];
import React from 'react';
import { MenuStyles } from "./Menu.styles.js";
export var Menu = function Menu(_ref) {
  var anchorEl = _ref.anchorEl,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    role = _ref.role,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MenuStyles.Menu, _extends({}, otherProps, {
    anchorEl: anchorEl,
    open: isOpen,
    onClose: onClose,
    MenuListProps: {
      role: role
    }
  }), children);
};